// ----------------------------------------------------------------------
// <copyright file="Izenda.SmartTag.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * IconDropdownSetting component
 */
!(function() {
  var React = require('react');
  var SmartTagStore = require('logic/Izenda.SmartTagStore');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var FloatAffixed = require('share/components/controls/Izenda.FloatAffixed');
  var connect = require('share/enhancers/Izenda.Connect');
  var { isNil, flow, orderBy, groupBy, forEach } = require('lodash/fp');

  var SmartTag = React.createClass({
    propTypes: {
      onChange: React.PropTypes.func
    },

    getInitialState: function() {
      return {
        isOpen: false
      };
    },

    componentWillMount: function() {
      this.smartTagStore = new SmartTagStore();
    },

    /**
     * OnClick sub total
     */
    onClickSubtotal: function() {
      this.hideMenu();
      var props = this.props;
      if (isNil(props.editorControl)) {
        return;
      }
      props.editorControl.insertSmartTag('Subtotal');
    },

    /**
     * OnClick grand total
     */
    onClickGrandTotal: function() {
      this.hideMenu();
      var props = this.props;
      if (isNil(props.editorControl)) {
        return;
      }
      props.editorControl.insertSmartTag('GrandTotal');
    },

    /**
     * OnClick date format
     */
    onClickDateFormat: function(dateFormat) {
      this.hideMenu();
      var props = this.props;
      if (isNil(props.editorControl)) {
        return;
      }
      props.editorControl.insertSmartTag('DateTime', dateFormat);
    },

    componentDidMount: function() {
      this.smartTagStore.getDateFormats();
    },

    /**
     * Render date format
     * returns {Object} date format component
     */
    renderDateFormat: function() {
      var dateFormatGroup = flow(
        orderBy('position', 'asc'),
        groupBy('category')
      )(this.smartTagStore.model.smartTags);

      var result = [];
      for (var key in dateFormatGroup) {
        var dateFormats = dateFormatGroup[key];

        result.push(
          <div className='u_textBold' key={key}>
            {key}
          </div>
        );
        forEach(
          function(dateFormat) {
            result.push(
              <div
                className='izenda-DateTimeItem u_paddingLeft'
                key={dateFormat.position}
                onClick={this.onClickDateFormat.bind(this, dateFormat.name)}
              >
                {dateFormat.name}
              </div>
            );
          }.bind(this),
          dateFormats
        );
      }

      return result;
    },

    showMenu: function(event) {
      event.stopPropagation();
      event.preventDefault();

      this.setState({ isOpen: !this.state.isOpen });
    },

    hideMenu: function() {
      this.setState({ isOpen: false });
    },

    /**
     * Render
     * returns {Object} component
     */
    render: function() {
      var props = this.props;
      var data = props.data;
      var localization = props.localization;

      return (
        <span className='u-posRelative izenda-SmartTag'>
          <a className='btn' title={data.title} ref='smartTag' onClick={this.showMenu}>
            <i className={data.className} />
            <span className='caret' />
          </a>
          {this.state.isOpen && (
            <FloatAffixed
              className='izenda-SmartTag'
              anchor={this.refs.smartTag}
              onClickOutside={this.hideMenu}
              onParentScroll={this.hideMenu}
            >
              <div className='izenda-SmartTag-list'>
                <div className='izenda-SmartTag-item'>
                  <a>{localization.getText('COMMON_LABEL_DATE_TIME')}</a>
                  <div className='izenda-SmartTag-hover'>
                    <div className='izenda-SmartTag-logo'>
                      <ScrollBox>{this.renderDateFormat()}</ScrollBox>
                    </div>
                  </div>
                </div>
                <div className='izenda-SmartTag-item'>
                  <a onClick={this.onClickSubtotal}>{localization.getText('COMMON_LABEL_SUBTOTAL')}</a>
                </div>
                <div className='izenda-SmartTag-item'>
                  <a onClick={this.onClickGrandTotal}>{localization.getText('COMMON_LABEL_GRAND_TOTAL')}</a>
                </div>
              </div>
            </FloatAffixed>
          )}
        </span>
      );
    }
  });

  module.exports = connect()(SmartTag);
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.SmartTag.jsx